import(/* webpackMode: "eager" */ "/app/src/app/ai-scans/screener/page.tsx");
